import TableReportHelper from "report/helper";

async function section(TipoClass, visita, tipoName) {
    const h = new TableReportHelper(visita.data);
    const content = [];
    const indicadores = [];

    for (const IndicadorClass of TipoClass.indicadores) {
        const indicador = new IndicadorClass(TipoClass);
        const summary = await indicador.renderReportSummary(visita, tipoName);

        if (summary) {
            indicadores.push(summary);
        }
    }
    if (!indicadores.length) {
        return null;
    }
    for (let i = 0; i < indicadores.length; i += 2) {
        const row = [];

        row.push(
            h.panel([
                // prettier-ignore
                h.row(
                    h.title(`${TipoClass.fullName} - ${tipoName}`, { fontSize: 10, alignment: "center" })
                ),
            ])
        );

        row.push(
            h.panel(
                [
                    // prettier-ignore
                    h.row(
                        indicadores[i],
                        indicadores[i + 1] || []
                    ),
                ],
                { widths: ["*", "*"] }
            )
        );

        content.push(h.unbreakable(row));
    }

    return content;
}

export default async function tipoIndicadorReportSummary(TipoClass, visita) {
    // return [await section(TipoClass, visita, "Manual"), await section(TipoClass, visita, "Mecanizado")];

    let cont = []
    let manual = await section(TipoClass, visita, "Manual")
    let mecanizado = await section(TipoClass, visita, "Mecanizado")
    
    if (manual) cont.push(manual)
    if (mecanizado) cont.push(mecanizado)

    return cont;
}
